export default __webpack_public_path__ + "static/media/guesty_step2.46795430.png";